import * as React from 'react';
import { Link } from 'react-router-dom';
import { buttonVariants } from './button';
import { cn } from '@/lib/utils';

const ButtonLink = React.forwardRef(
  ({ className, variant, size, to, ...props }, ref) => (
    <Link
      ref={ref}
      to={to}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
);
ButtonLink.displayName = 'ButtonLink';

export { ButtonLink };
